module.exports = __webpack_public_path__ + "img/yourthoughts.516dacec.svg";